import { Route } from 'react-router-dom';

import PageNotFoundView from 'targets/web/modules/dashboard/views/PageNotFound.view';

const PublicRoutes = (
  <Route>
    <Route path="*" element={<PageNotFoundView />} />
  </Route>
);

export default PublicRoutes;
